const imageSliderJsonArrayA = [
    {
        'title': '한 곳으로 업무가 모여 누락이 사라졌어요.',
        'description': '모든 기기에서 지원되기 때문에 업무환경에 구애받지 않고 사용할 수 있었고, 담당자를 지정한 디테일한 기능이 업무 처리에 있어서 효과적이에요.',
        'img': '/flow-renewal/assets/images/flowting-project/ci-logiall.svg',
        'associateName': '최규범 부대표',
        'profileImage': '/flow-renewal/assets/images/flowting-project/associate-1.png'
    },
    {
        'title': '전국 15,000개 점포와 실시간 소통해요.',
        'description': '편의점 특성상 수시로 신상품이 나오고 행사가 진행되는데, 이슈가 있을 때 마다 모바일로 소통할 수 있어서 즉각적인 피드백이 가능해졌어요.',
        'img': '/flow-renewal/assets/images/flowting-project/ci-bgf.svg',
        'associateName': '류대성 책임',
        'profileImage': '/flow-renewal/assets/images/flowting-project/associate-2.png'
    },
    {
        'title': '불필요한 업무 관리 시간이 감소됐어요.',
        'description': '업무 진행을 하면서 쌓이는 모든 데이터가 플로우 안에 보관되어 있어서 별도의 히스토리 관리를 할 필요가 없어졌어요.',
        'img': '/flow-renewal/assets/images/flowting-project/ci-artbox.svg',
        'associateName': '이락연 팀장',
        'profileImage': '/flow-renewal/assets/images/flowting-project/associate-3.png'
    }
]

const imageSliderJsonArrayB = [
    {
        'title': '90%',
        'subTitle': '업무 누락 감소',
        'description': '업무 누락과 자료 유실이<br/> 발생하지 않게 되었어요.',
        'graphImage': '/flow-renewal/assets/images/flowting-project/data-1.png'
    },
    {
        'title': '70%',
        'subTitle': '커뮤니케이션 비용 감소',
        'description': '정보 전달과 소통에 들어가는<br/> 리소스가 감소되었어요.',
        'graphImage': '/flow-renewal/assets/images/flowting-project/data-2.png'
    },
    {
        'title': '4.9H',
        'subTitle': '히스토리 관리시간 감소',
        'description': '업무 가시화로 불필요한<br/> 관리시간이 단축되었어요.',
        'graphImage': '/flow-renewal/assets/images/flowting-project/data-3.png'
    }
]

export {
    imageSliderJsonArrayA,
    imageSliderJsonArrayB
}
